import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const sendMFACodeActions = createDataModuleActions('SEND_MFA_CODE');
export const sendMFACode = sendMFACodeActions.dataRequest;
export const sendMFACodeSuccess = sendMFACodeActions.dataSuccess;
export const sendMFACodeError = sendMFACodeActions.dataError;
